var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.006 7.125a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zM8.003 7.125a1 1 0 0 1 0 2h-.006a1 1 0 0 1 0-2zM12.006 7.125a1 1 0 0 1 0 2H12a1 1 0 1 1 0-2z"
  })));
};
export default Svg16;